import { Injectable } from "@angular/core";
import { BaseService, ServiceResponse } from "../base.service";
import { environment } from "src/environments/environment";
import { lastValueFrom } from "rxjs";
import { IndexDBService } from "../indexd-db/indexd-db.service";
import { Cobro } from "src/app/models/cobranza/cobro.model";

@Injectable({
    providedIn: 'root'
})
export class CobroService extends BaseService {
    
    override recordName = 'cobros';

    override url = `${ environment.host }/cobro`;
    override codigoRegistro = Cobro.CODIGO_REGISTRO;

    override async put(id: number, body: any): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            this.header['filters'] = JSON.stringify(await this.getAdicionalFilters( true ));
            this.body = body;
            delete this.body.id;
            let url = `${this.url}/${id}`;
            const resp = await lastValueFrom( this.http.put<ServiceResponse>(url, this.body, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            console.log(error);
            
            return this.checkError( error );
        }
    }

    async actualizarCobro( body?: Record<string, any>) {      
        let url = `${this.url}/actualizar-cobro`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async recalcularComision(body?: Record<string, any>) {      
        let url = `${this.url}/recalcular-comision`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  body , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async filtrarCobros( filtros: Record<string, any> ) {          
        let url = `${this.url}/filtrar-cobros`;
        try {
            await this.updateToken();
            const resp = await lastValueFrom(this.http.post<any>(url,  filtros , { headers: this.header }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }


}